// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"fill":"currentColor","d":"M19.0001 2.09155V22.7897L3.17212 13.0494L19.0001 2.09155Z"},"nodeName":"path","children":[]}]};

@tag('t-icon-delta-filled')
export default class DeltaFilledIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'delta-filled',
    }
  }
}
